// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__rMb4v","options":"style_options__1XiSQ","title":"style_title__3ytd3","content":"style_content__26glE","list":"style_list__1tfry"};